export const VIEW = {
    WIZARD: "WIZARD",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
};
